import React from "react";
import { Container } from "react-bootstrap";
import { FaCheck, FaCircle } from "react-icons/fa";

export default function CopyPackageStepper({
  steps,
  currentStep,
  setCurrentStep,
  isEditable,
  isCopyMode,
}) {
  return (
    <Container
      fluid
      className="position-sticky top-0 bg-light py-3 shadow-sm d-none d-md-flex align-items-center"
      style={{ zIndex: 1020 }}
    >
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        const canClick =
          isEditable ||
          index <= currentStep;

        return (
          <React.Fragment key={index}>
            <div className="d-flex align-items-center gap-3 flex-grow-1">
              {/* Circle */}
              <div
                onClick={() => {
                  if (!canClick) return;
                  setCurrentStep(index);
                }}
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  backgroundColor: isCompleted
                    ? "#1E0959"
                    : isActive
                      ? "#F4C430"
                      : "#e0e0e0",
                  color: isCompleted || isActive ? "#fff" : "#9e9e9e",
                  cursor: canClick ? "pointer" : "not-allowed",
                  transition: "all 0.3s ease",
                }}
                className="d-flex align-items-center justify-content-center shadow-sm"
              >
                {isCompleted ? <FaCheck /> : <FaCircle size={12} />}
              </div>

              {/* Label */}
              <div
                onClick={() => {
                  if (!canClick) return;
                  setCurrentStep(index);
                }}
                style={{ cursor: canClick ? "pointer" : "not-allowed" }}
              >
                <div
                  className="fw-semibold"
                  style={{
                    color: isActive ? "#1E0959" : isCompleted ? "#000" : "#777",
                  }}
                >
                  {step}
                </div>

                {isActive && (
                  <div
                    style={{
                      height: "3px",
                      width: "60%",
                      backgroundColor: "#F4C430",
                      marginTop: "4px",
                      borderRadius: "5px",
                    }}
                  />
                )}
              </div>
            </div>

            {/* Line */}
            {index !== steps.length - 1 && (
              <div
                style={{
                  flex: 2,
                  height: "3px",
                  backgroundColor: index < currentStep ? "#1E0959" : "#d3d3d3",
                  margin: "0 15px",
                  transition: "0.3s",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Container>
  );
}
